<template>
  <div class="inno-select" v-click-outside="close">
    <div class="inno-select-display" @click="toggle">
      <span v-if="displayLabel">{{ displayLabel }}</span>
      <span v-else class="placeholder">{{ placeholder }}</span>
      <span class="arrow" :class="{ 'is-open': isOpen }">▼</span>
    </div>

    <ul v-if="isOpen" class="inno-select-dropdown">
      <li 
        v-for="opt in options" 
        :key="opt.value"
        :class="{ 'is-selected': internalValue === opt.value }"
        @click="pick(opt)"
      >
        {{ opt.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InnoSelect',
  // 同時定義 value 和 modelValue，確保版本相容
  props: {
    value: [String, Number],      // Vue 2 預設
    modelValue: [String, Number], // Vue 3 預設
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '請選擇'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    // 統一取值邏輯
    internalValue() {
      // 優先取 modelValue (Vue3)，若無則取 value (Vue2)
      return (this.modelValue !== undefined) ? this.modelValue : this.value;
    },
    displayLabel() {
      const target = this.options.find(o => o.value === this.internalValue);
      return target ? target.label : '';
    }
  },
  methods: {
    toggle() { this.isOpen = !this.isOpen; },
    close() { this.isOpen = false; },
    pick(opt) {
      // 同時發送兩組事件，確保父組件的 v-model 能收到
      this.$emit('input', opt.value);             // Vue 2
      this.$emit('update:modelValue', opt.value);  // Vue 3
      this.$emit('change', opt.value);
      this.isOpen = false;
    }
  },
  directives: {
    clickOutside: {
      // 這裡也做 Vue 2 (bind) 與 Vue 3 (mounted) 的相容
      [typeof window !== 'undefined' && 'mounted' in {} ? 'mounted' : 'bind'](el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      [typeof window !== 'undefined' && 'unmounted' in {} ? 'unmounted' : 'unbind'](el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style scoped>
/* 樣式保持不變，確保美觀 */
.inno-select { position: relative; width: 240px; font-size: 14px; user-select: none; }
.inno-select-display { background: #fff; border: 1px solid #dcdfe6; border-radius: 4px; padding: 8px 12px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; }
.inno-select-dropdown { position: absolute; top: 100%; left: 0; right: 0; background: #fff; border: 1px solid #e4e7ed; z-index: 1000; padding: 5px 0; margin-top: 4px; list-style: none; box-shadow: 0 2px 12px rgba(0,0,0,0.1); }
.inno-select-dropdown li { padding: 8px 15px; cursor: pointer; }
.inno-select-dropdown li:hover { background: #f5f7fa; }
.inno-select-dropdown li.is-selected { color: #409eff; background: #f0f7ff; font-weight: bold; }
.arrow { transition: transform 0.3s; color: #c0c4cc; }
.arrow.is-open { transform: rotate(180deg); }
</style>